import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  contactUpdated: 'A Contact has been updated. Please review this section.',
  dismiss: 'Dismiss',
})
